/* JADUZAR GROUP — group design system behaviour.

   Progressive throughout: without this file every link, form and section
   still renders and works. It adds the header's scrolled state, dropdowns
   and mobile sheet, the hero's video loading and phone rotation, the
   ventures track arrows and the scroll reveals.

   init() is idempotent and re-runs on shopify:section:load, so a section the
   Theme Editor re-renders rebinds itself. */
(function () {
  'use strict';

  var doc = document;
  var html = doc.documentElement;
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mqPhone = window.matchMedia('(max-width: 820px)');
  var mqSheet = window.matchMedia('(max-width: 980px)');

  function all(root, sel) {
    return Array.prototype.slice.call((root || doc).querySelectorAll(sel));
  }
  function once(el, key) {
    var k = 'jg' + key;
    if (el.dataset[k]) return false;
    el.dataset[k] = '1';
    return true;
  }

  /* ---- Header ---------------------------------------------------------- */
  function initHeader(root) {
    all(root, '[data-jg-head]').forEach(function (head) {
      if (!once(head, 'Head')) return;

      /* Scrolled state from a sentinel, not a scroll listener. */
      var sentinel = doc.querySelector('[data-jg-sentinel]');
      if (sentinel && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          head.classList.toggle('is-scrolled', !entries[0].isIntersecting);
        }).observe(sentinel);
      }

      var burger = head.querySelector('[data-jg-burger]');
      var drops = all(head, '[data-jg-drop]');

      function closeDrops(except) {
        drops.forEach(function (item) {
          if (item === except) return;
          item.removeAttribute('data-open');
          var b = item.querySelector('.jg-nav__link');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        head.classList.toggle('is-open', !!except);
      }
      function setMenu(open) {
        if (open) head.setAttribute('data-menu-open', '');
        else head.removeAttribute('data-menu-open');
        if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        html.style.overflow = open ? 'hidden' : '';
        if (!open) closeDrops(null);
      }

      drops.forEach(function (item) {
        var btn = item.querySelector('.jg-nav__link');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var open = !item.hasAttribute('data-open');
          closeDrops(open ? item : null);
          if (open) item.setAttribute('data-open', '');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          /* A click that closes must also end the hover/focus-driven state. */
          if (!open) btn.blur();
        });
        /* The bar takes its ground while a panel is showing on hover. */
        item.addEventListener('mouseenter', function () {
          if (!mqSheet.matches) head.classList.add('is-open');
        });
        item.addEventListener('mouseleave', function () {
          if (!mqSheet.matches && !head.querySelector('[data-jg-drop][data-open]')) head.classList.remove('is-open');
        });
      });

      if (burger) {
        burger.addEventListener('click', function () {
          setMenu(!head.hasAttribute('data-menu-open'));
        });
      }
      head.addEventListener('click', function (e) {
        var a = e.target.closest('a');
        if (a && head.hasAttribute('data-menu-open')) setMenu(false);
        else if (a) closeDrops(null);
      });
      doc.addEventListener('click', function (e) {
        if (!head.contains(e.target)) closeDrops(null);
      });
      doc.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (head.hasAttribute('data-menu-open')) { setMenu(false); if (burger) burger.focus(); return; }
        var open = head.querySelector('[data-jg-drop][data-open]');
        if (open) { closeDrops(null); var b = open.querySelector('.jg-nav__link'); if (b) b.focus(); }
      });
      var onWide = function () { if (!mqSheet.matches) setMenu(false); };
      if (mqSheet.addEventListener) mqSheet.addEventListener('change', onWide);
      else if (mqSheet.addListener) mqSheet.addListener(onWide);
    });

    all(root, '[data-jg-locale]').forEach(function (d) {
      if (!once(d, 'Locale')) return;
      doc.addEventListener('click', function (e) { if (d.open && !d.contains(e.target)) d.open = false; });
      doc.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && d.open) { d.open = false; var su = d.querySelector('summary'); if (su) su.focus(); }
      });
    });
  }

  /* ---- Hero ------------------------------------------------------------ */
  /* Video is an enhancement over the still. It is skipped entirely for
     visitors who ask for reduced motion or data saving, and on very slow
     connections; the still image is then the hero. */
  function videoAllowed() {
    if (mqReduce.matches) return false;
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) return false;
    return true;
  }

  function initHero(root) {
    all(root, '[data-jg-hero]').forEach(function (hero) {
      if (!once(hero, 'Hero')) return;
      var panels = all(hero, '[data-jg-panel]');
      var tabs = all(hero, '[data-jg-tab]');
      if (!panels.length) return;

      var allow = videoAllowed();
      var visible = true;
      var active = 0;
      var timer = null;
      var interval = Math.max(3, Number(hero.getAttribute('data-interval')) || 6) * 1000;

      function videoOf(panel) { return panel.querySelector('[data-jg-video]'); }

      function start(panel) {
        var v = videoOf(panel);
        if (!v || !allow) return;
        if (!v.getAttribute('src')) {
          var src = (mqPhone.matches && v.getAttribute('data-src-mobile')) || v.getAttribute('data-src');
          if (!src) return;
          v.muted = true;
          v.addEventListener('playing', function () { panel.classList.add('is-playing'); });
          v.setAttribute('src', src);
        }
        if (!visible || doc.hidden) return;
        var p = v.play();
        if (p && p.catch) p.catch(function () { /* autoplay refused: the still stays */ });
      }
      function stop(panel) {
        var v = videoOf(panel);
        if (v && v.getAttribute('src') && !v.paused) v.pause();
      }

      /* Desktop: every slice is on screen, so each video is started — the
         first at once, the rest in sequence so they never compete with the
         page's own first paint. Phone: only the slice being shown. */
      function sync() {
        if (mqPhone.matches) {
          panels.forEach(function (p, i) { if (i === active) start(p); else stop(p); });
        } else {
          panels.forEach(function (p, i) {
            if (videoOf(p) && videoOf(p).getAttribute('src')) start(p);
            else window.setTimeout(function () { if (!mqPhone.matches) start(p); }, i * 350);
          });
        }
      }

      function show(i, user) {
        active = (i + panels.length) % panels.length;
        panels.forEach(function (p, n) { p.classList.toggle('is-active', n === active); });
        tabs.forEach(function (t, n) {
          t.classList.toggle('is-active', n === active);
          t.classList.toggle('is-done', n < active);
          t.setAttribute('aria-pressed', n === active ? 'true' : 'false');
        });
        if (mqPhone.matches) sync();
        if (user) restart();
      }
      function restart() {
        window.clearInterval(timer);
        timer = null;
        var auto = mqPhone.matches && !mqReduce.matches && panels.length > 1 && visible && !doc.hidden;
        if (auto) {
          hero.setAttribute('data-auto', '');
          timer = window.setInterval(function () { show(active + 1); }, interval);
        } else {
          hero.removeAttribute('data-auto');
        }
      }

      tabs.forEach(function (t, n) {
        t.addEventListener('click', function () { show(n, true); });
      });

      /* Swipe between worlds on a phone. */
      var x0 = null, y0 = null;
      hero.addEventListener('touchstart', function (e) {
        if (!mqPhone.matches || e.touches.length !== 1) { x0 = null; return; }
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) show(active + (dx < 0 ? 1 : -1), true);
      }, { passive: true });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) sync(); else panels.forEach(stop);
          restart();
        }, { threshold: 0.05 }).observe(hero);
      }
      doc.addEventListener('visibilitychange', function () {
        if (doc.hidden) panels.forEach(stop); else if (visible) sync();
        restart();
      });
      var onMode = function () { show(active); sync(); restart(); };
      if (mqPhone.addEventListener) mqPhone.addEventListener('change', onMode);
      else if (mqPhone.addListener) mqPhone.addListener(onMode);

      hero.setAttribute('data-ready', '');
      show(0);
      /* Let the page's first paint finish before any video is requested. */
      var go = function () { sync(); restart(); };
      if (doc.readyState === 'complete') go();
      else window.addEventListener('load', go, { once: true });
    });
  }

  /* ---- Ventures track -------------------------------------------------- */
  function initTrack(root) {
    all(root, '[data-jg-track]').forEach(function (track) {
      if (!once(track, 'Track')) return;
      var host = track.closest('section') || doc;
      var prev = host.querySelector('[data-jg-prev]');
      var next = host.querySelector('[data-jg-next]');
      if (!prev || !next) return;

      function step() {
        var card = track.firstElementChild;
        if (!card) return track.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: mqReduce.matches ? 'auto' : 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: mqReduce.matches ? 'auto' : 'smooth' }); });
      var raf = 0;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = window.requestAnimationFrame(function () { raf = 0; update(); });
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---- Request intake --------------------------------------------------
     A multi-step view over one ordinary Shopify contact form. Nothing is
     sent from here: the browser submits the form as it would without this
     script. The script only decides which step is on screen, checks a step
     before leaving it, and carries a short summary to the confirmation. */
  function initIntake(root) {
    all(root, '[data-jg-intake]').forEach(function (box) {
      if (!once(box, 'Intake')) return;
      var form = box.closest('form');
      var steps = all(box, '[data-jg-step]');
      if (!form || !steps.length) return;

      var next = box.querySelector('[data-jg-next]');
      var back = box.querySelector('[data-jg-back]');
      var submit = box.querySelector('[data-jg-submit]');
      var progress = box.querySelector('[data-jg-progress]');
      var progressText = box.querySelector('[data-jg-progress-text]');
      var progressBar = box.querySelector('[data-jg-progress-bar]');
      var review = box.querySelector('[data-jg-review]');
      var reviewList = box.querySelector('[data-jg-review-list]');
      var msg = {
        required: box.getAttribute('data-err-required') || 'Please fill in this field.',
        choice: box.getAttribute('data-err-choice') || 'Please choose an option.',
        email: box.getAttribute('data-err-email') || 'Please enter a valid email address.'
      };
      var at = 0;
      var last = steps.length - 1;

      form.noValidate = true;
      box.classList.add('is-stepped');
      if (progress) progress.hidden = false;

      function control(field) { return field.querySelector('input:not([type=radio]):not([type=hidden]), select, textarea'); }
      function radios(field) { return all(field, 'input[type=radio]'); }
      function valueOf(field) {
        var r = radios(field);
        if (r.length) { for (var i = 0; i < r.length; i++) if (r[i].checked) return r[i].value; return ''; }
        var c = control(field);
        if (!c) return '';
        if (c.type === 'checkbox') return c.checked ? c.value : '';
        return (c.value || '').trim();
      }
      function setError(field, text) {
        var el = field.querySelector('[data-jg-error]');
        var c = control(field);
        if (el) { el.textContent = text || ''; el.hidden = !text; }
        field.classList.toggle('has-error', !!text);
        if (c) { if (text) c.setAttribute('aria-invalid', 'true'); else c.removeAttribute('aria-invalid'); }
      }
      function check(field) {
        var v = valueOf(field);
        var c = control(field);
        var required = field.hasAttribute('data-required');
        var text = '';
        if (required && !v) text = (radios(field).length || field.hasAttribute('data-consent')) ? msg.choice : msg.required;
        else if (v && c && c.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) text = msg.email;
        setError(field, text);
        return !text;
      }
      function checkStep(i) {
        var ok = true, first = null;
        all(steps[i], '[data-jg-field]').forEach(function (f) {
          if (!check(f)) { ok = false; if (!first) first = f; }
        });
        if (first) {
          var target = first.querySelector('input, select, textarea');
          if (target) target.focus();
        }
        return ok;
      }

      function buildReview() {
        if (!review || !reviewList) return;
        reviewList.textContent = '';
        var n = 0;
        all(box, '[data-jg-field]').forEach(function (f) {
          if (f.hasAttribute('data-consent')) return;
          var v = valueOf(f);
          if (!v) return;
          var row = doc.createElement('div');
          var dt = doc.createElement('dt'); dt.textContent = f.getAttribute('data-label') || '';
          var dd = doc.createElement('dd'); dd.textContent = v.length > 160 ? v.slice(0, 157) + '…' : v;
          row.appendChild(dt); row.appendChild(dd); reviewList.appendChild(row); n++;
        });
        review.hidden = n === 0;
      }

      function show(i, focus) {
        at = Math.max(0, Math.min(last, i));
        steps.forEach(function (st, n) { st.hidden = n !== at; });
        if (back) back.hidden = at === 0;
        if (next) next.hidden = at === last;
        if (submit) submit.hidden = at !== last;
        if (review) { if (at === last) buildReview(); else review.hidden = true; }
        if (progressText) {
          progressText.textContent = (box.getAttribute('data-step-text') || 'Step [current] of [total]')
            .replace('[current]', at + 1).replace('[total]', steps.length);
        }
        if (progressBar) progressBar.style.transform = 'scaleX(' + ((at + 1) / steps.length) + ')';
        if (focus) {
          var top = box.getBoundingClientRect().top;
          if (top < 90 || top > window.innerHeight * 0.6) {
            window.scrollTo({ top: window.pageYOffset + top - 110, behavior: mqReduce.matches ? 'auto' : 'smooth' });
          }
          var h = steps[at].querySelector('.jg-step__title');
          if (h) h.focus({ preventScroll: true });
        }
      }

      /* A notice tied to particular answers (for example an urgent deadline). */
      all(box, '[data-jg-alert]').forEach(function (note) {
        var field = note.closest('[data-jg-field]');
        var values = (note.getAttribute('data-values') || '').split('|').map(function (v) { return v.trim(); }).filter(Boolean);
        if (!field) return;
        field.addEventListener('change', function () { note.hidden = values.indexOf(valueOf(field)) === -1; });
      });

      box.addEventListener('input', function (e) {
        var f = e.target.closest('[data-jg-field]');
        if (f && f.classList.contains('has-error')) check(f);
      });
      box.addEventListener('change', function (e) {
        var f = e.target.closest('[data-jg-field]');
        if (f && f.classList.contains('has-error')) check(f);
      });

      if (next) next.addEventListener('click', function () { if (checkStep(at)) show(at + 1, true); });
      if (back) back.addEventListener('click', function () { show(at - 1, true); });
      form.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' || at === last) return;
        var t = e.target;
        if (t.tagName === 'TEXTAREA' || t.tagName === 'BUTTON' || t.tagName === 'A') return;
        e.preventDefault();
        if (checkStep(at)) show(at + 1, true);
      });

      form.addEventListener('submit', function (e) {
        for (var i = 0; i < steps.length; i++) {
          steps[i].hidden = false;
          var ok = checkStep(i);
          steps[i].hidden = i !== at;
          if (!ok) { e.preventDefault(); show(i, true); checkStep(i); return; }
        }
        var ref = '';
        var refInput = box.querySelector('[data-jg-ref]');
        if (refInput) {
          var d = new Date();
          var abc = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
          var tail = '';
          for (var k = 0; k < 4; k++) tail += abc.charAt(Math.floor(Math.random() * abc.length));
          ref = (box.getAttribute('data-prefix') || 'REF') + '-' +
            String(d.getFullYear()).slice(2) + ('0' + (d.getMonth() + 1)).slice(-2) + ('0' + d.getDate()).slice(-2) + '-' + tail;
          refInput.value = ref;
        }
        var wanted = (box.getAttribute('data-summary') || '').split(/\n/).map(function (v) { return v.trim(); }).filter(Boolean);
        var rows = [];
        all(box, '[data-jg-field]').forEach(function (f) {
          var label = f.getAttribute('data-label');
          if (wanted.indexOf(label) !== -1 && valueOf(f)) rows.push({ label: label, value: valueOf(f) });
        });
        try { window.sessionStorage.setItem('jg-intake:' + form.id, JSON.stringify({ ref: ref, rows: rows })); } catch (x) { /* private mode: the confirmation simply shows less */ }
        if (submit) submit.setAttribute('aria-disabled', 'true');
      });

      /* The Theme Editor asks for a step by selecting its block. */
      box.addEventListener('jg:step', function (e) { var i = steps.indexOf(e.detail); if (i !== -1) show(i, false); });

      show(0, false);
    });

    /* Confirmation: fill in what the visitor just sent. */
    all(root, '[data-jg-intake-done]').forEach(function (done) {
      if (!once(done, 'Done')) return;
      var key = 'jg-intake:' + done.getAttribute('data-jg-intake-done');
      var data = null;
      try { data = JSON.parse(window.sessionStorage.getItem(key) || 'null'); window.sessionStorage.removeItem(key); } catch (x) { data = null; }
      if (data) {
        var refRow = done.querySelector('[data-jg-done-ref]');
        if (refRow && data.ref) { refRow.querySelector('dd').textContent = data.ref; refRow.hidden = false; }
        var tpl = done.querySelector('[data-jg-done-row]');
        if (tpl && data.rows) {
          data.rows.forEach(function (r) {
            var row = tpl.cloneNode(true);
            row.removeAttribute('data-jg-done-row');
            row.querySelector('dt').textContent = r.label;
            row.querySelector('dd').textContent = r.value;
            row.hidden = false;
            tpl.parentNode.insertBefore(row, tpl);
          });
        }
      }
      if (done.scrollIntoView) done.scrollIntoView({ block: 'center' });
      done.focus({ preventScroll: true });
    });
  }

  /* ---- Reveal ---------------------------------------------------------- */
  var io = null;
  function initReveal(root) {
    if (mqReduce.matches || !('IntersectionObserver' in window) || doc.body.classList.contains('jg-still')) return;
    var targets = all(root, '.jg-reveal:not([data-jg-seen])');
    if (!targets.length) return;
    html.classList.add('jg-motion');
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    }
    targets.forEach(function (el) {
      el.setAttribute('data-jg-seen', '1');
      io.observe(el);
    });
  }
  function revealNow(root) {
    all(root, '.jg-reveal').forEach(function (el) {
      el.classList.add('is-in');
      el.setAttribute('data-jg-seen', '1');
    });
  }

  function init(root) {
    initHeader(root);
    initHero(root);
    initTrack(root);
    initIntake(root);
    initReveal(root);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  else init(doc);

  doc.addEventListener('shopify:section:load', function (e) { init(e.target); revealNow(e.target); });
  doc.addEventListener('shopify:section:select', function (e) { revealNow(e.target); });
  doc.addEventListener('shopify:block:select', function (e) {
    revealNow(e.target);
    /* Selecting a hero panel in the editor brings it forward on a phone-width preview. */
    var panel = e.target.closest && e.target.closest('[data-jg-panel]');
    if (panel) {
      var hero = panel.closest('[data-jg-hero]');
      var idx = all(hero, '[data-jg-panel]').indexOf(panel);
      var tab = all(hero, '[data-jg-tab]')[idx];
      if (tab) tab.click();
    }
    var step = e.target.closest && e.target.closest('[data-jg-step]');
    if (step) step.closest('[data-jg-intake]').dispatchEvent(new CustomEvent('jg:step', { detail: step }));
    var card = e.target.closest && e.target.closest('.jg-venture');
    if (card && card.scrollIntoView) card.scrollIntoView({ block: 'nearest', inline: 'start' });
  });
})();
